<template>
  <WhatsHappeningMeetingEntry :entry="entry" v-if="meeting"/>
  <WhatsHappeningNonMeetingEntry :entry="entry" v-else/>
</template>


<script>
import WhatsHappeningNonMeetingEntry from './WhatsHappeningNonMeetingEntry'
import WhatsHappeningMeetingEntry from './WhatsHappeningMeetingEntry'

export default {
  name: 'WhatsHappeningEntry',
  props: ['entry'],
  components: {WhatsHappeningNonMeetingEntry, WhatsHappeningMeetingEntry},
  computed: {
    meeting() {
      return this.entry.type == 'meeting'
    }
  }
}
</script>
